module.exports = datatables.net;